<template>
  <div>
    <b-row>
      <b-col>
        <profile-info
          :team="team"
          :team-kudos="teamKudos"
          :members="members"
          :editable="editable"
          @edit="$emit('edit', { team })"
        >
          <slot />
        </profile-info>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="12" lg="6" xl="4" class="mb-4">
        <facts
          :facts="team.facts"
          :editable="editable"
          @edit="$emit('edit', { team, from: 'facts' })"
        />
      </b-col>
      <b-col md="12" lg="6" xl="4" class="mb-4">
        <values
          :contract="team.contract"
          :editable="editable"
          @edit="$emit('edit', { team, from: 'values' })"
        />
      </b-col>
      <b-col md="12" lg="6" xl="4" class="mb-4">
        <highlight
          :video="team.video"
          :editable="editable"
          @edit="$emit('edit', { team, from: 'highlight' })"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ProfileInfo from './ProfileInfo.vue'
import Facts from './Facts.vue'
import Values from './Values.vue'
import Highlight from './Highlight.vue'

export default {
  name: 'TeamProfile',

  props: {
    team: {
      type: Object,
      required: true
    },

    teamKudos: {
      type: Object
    },

    members: {
      type: Object,
      default: () => ({})
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ProfileInfo,
    Facts,
    Values,
    Highlight
  }
}
</script>
